import { observable, action } from 'mobx';
import config from 'config';
import HttpClient from 'utils/httpclient';
import { LOADING, LOADED } from 'stores/BaseStore';
import Moment from 'moment-timezone';

class ReportsFailureStore {
  @observable data = null;
  @observable searchData = null;
  @observable status = LOADED;

  @action getFailure (queryParams) {
    if (!queryParams.siteId) {
      this.data = null;
      this.searchData = null;
      this.status = LOADED;
      return;
    }

    this.status = LOADING;
    let params = {};
    params.searchStartDate = Moment(queryParams.searchStartDate).format('YYYY-MM-DD');
    params.searchEndDate = Moment(queryParams.searchEndDate).format('YYYY-MM-DD');
    params.siteId = queryParams.siteId;
    
    return HttpClient.get(`${config.api}/reports/site/${queryParams.siteId}/failure`, { params })
      .then(response => {
        this.data = response.data;
        this.searchData = response.data;
        return response;
      }).finally(() => this.status = LOADED);
  }

  @action search (searchTerm) {
    if (this.data && this.data.length) {
      this.searchData = this.data.filter(obj => obj.name.toLowerCase().includes(searchTerm.toLowerCase()));
      return this.searchData;
    }
    return;
  }
}

export default new ReportsFailureStore();
